"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("./components/Button"));
const yellow_alone_svg_1 = __importDefault(require("../svg/yellow_alone.svg"));
const red_alone_svg_1 = __importDefault(require("../svg/red_alone.svg"));
const Boop_1 = require("./components/Boop");
const react_spring_1 = require("react-spring");
const classnames_1 = __importDefault(require("classnames"));
const useStyles = (0, react_jss_1.createUseStyles)({
    background: {
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    logoStripe: {
        height: "25vh",
        width: "100%",
        display: "flex",
        background: "#ECECEC",
        alignItems: "center",
        justifyContent: "center",
    },
    logo: {
        height: "75%",
        maxWidth: "100%",
    },
    buttonBox: {
        display: "flex",
        flexDirection: "column",
        padding: "30px 0",
    },
    buttonRow: {
        padding: "10px 0",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    button: {
        width: 160,
        margin: "0 15px",
    },
    smiley: {
        height: 60,
    },
    rotatedLeft: {
        transform: "rotate(-25deg)",
    },
    rotatedRight: {
        transform: "rotate(25deg)",
    },
    transformedRed: {
        transform: "rotate(25deg) ", //translate(-15px, -10px)
    },
    translatedLeft: {
        transform: "translateX(-10px)",
    },
    aboveRed: {
        zIndex: "1",
    },
    onTop: {
        zIndex: "2",
    },
    shadow: {
        marginTop: -4,
        width: 55,
        height: 7,
        alignSelf: "center",
        borderRadius: "50%",
        background: "grey",
    },
    smileyWithShadow: {
        height: 80,
        display: "flex",
        flexDirection: "column",
    },
});
const LandingPage = () => {
    const classes = useStyles();
    const { style: styleSingle, trigger: triggerSingle } = (0, Boop_1.useBoop)({
        rotation: 0,
        timing: 200,
        y: -10,
        springConfig: { tension: 300, friction: 10 },
    });
    const { style: styleSingleShadow, trigger: triggerSingleShadow } = (0, Boop_1.useBoop)({
        rotation: 0,
        timing: 200,
        scale: 0.8,
        springConfig: { tension: 300, friction: 10 },
    });
    const { style: styleMulti1, trigger: triggerMulti1 } = (0, Boop_1.useBoop)({
        rotation: 0,
        timing: 200,
        y: -10,
        springConfig: { tension: 300, friction: 10 },
        delay: 100,
    });
    const { style: styleMultiShadow1, trigger: triggerMultiShadow1 } = (0, Boop_1.useBoop)({
        rotation: 0,
        timing: 200,
        scale: 0.8,
        springConfig: { tension: 300, friction: 10 },
        delay: 100,
    });
    const { style: styleMulti2, trigger: triggerMulti2 } = (0, Boop_1.useBoop)({
        rotation: 0,
        timing: 200,
        y: -10,
        springConfig: { tension: 300, friction: 10 },
    });
    const { style: styleMultiShadow2, trigger: triggerMultiShadow2 } = (0, Boop_1.useBoop)({
        rotation: 0,
        timing: 200,
        scale: 0.8,
        springConfig: { tension: 300, friction: 10 },
    });
    return (react_1.default.createElement("div", { className: classes.background },
        react_1.default.createElement("div", { className: classes.logoStripe },
            react_1.default.createElement("img", { src: require("!file-loader!../svg/logo.svg").default, className: classes.logo })),
        react_1.default.createElement("div", { className: classes.buttonBox },
            react_1.default.createElement("div", { className: classes.buttonRow },
                react_1.default.createElement(Button_1.default, { Component: react_router_dom_1.Link, to: "/singleplayer", className: classes.button, onMouseEnter: () => {
                        triggerSingle();
                        triggerSingleShadow();
                    } }, "Single player"),
                react_1.default.createElement("div", { className: classes.smileyWithShadow },
                    react_1.default.createElement(react_spring_1.animated.span, { className: classes.onTop, style: styleSingle },
                        react_1.default.createElement(yellow_alone_svg_1.default, { className: (0, classnames_1.default)(classes.smiley, classes.rotatedRight) })),
                    react_1.default.createElement(react_spring_1.animated.div, { className: classes.shadow, style: styleSingleShadow }))),
            react_1.default.createElement("div", { className: classes.buttonRow },
                react_1.default.createElement("div", { className: classes.smileyWithShadow },
                    react_1.default.createElement(react_spring_1.animated.span, { style: styleMulti1, className: classes.onTop },
                        react_1.default.createElement("div", { className: classes.aboveRed },
                            react_1.default.createElement(yellow_alone_svg_1.default, { className: (0, classnames_1.default)(classes.smiley, classes.rotatedLeft) }))),
                    react_1.default.createElement(react_spring_1.animated.div, { className: classes.shadow, style: styleMultiShadow1 })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.smileyWithShadow, classes.translatedLeft) },
                    react_1.default.createElement(react_spring_1.animated.span, { style: styleMulti2, className: classes.onTop },
                        react_1.default.createElement(red_alone_svg_1.default, { className: (0, classnames_1.default)(classes.smiley, classes.transformedRed) })),
                    react_1.default.createElement(react_spring_1.animated.div, { className: classes.shadow, style: styleMultiShadow2 })),
                react_1.default.createElement(Button_1.default, { Component: react_router_dom_1.Link, to: "/multiplayer", className: classes.button, onMouseEnter: () => {
                        triggerMulti1();
                        triggerMulti2();
                        triggerMultiShadow1();
                        triggerMultiShadow2();
                    } }, "Multiplayer")))));
};
exports.default = LandingPage;
